import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimHistoryListRequestDto } from "../../dtos/get-claim-history-list-request-dto";
import type { GetClaimHistoryListResponseDto } from "../../dtos/get-claim-history-list-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimHistoryListQueryParams = {
  queryParams: GetClaimHistoryListRequestDto;
  options?: Omit<UseQueryOptions<GetClaimHistoryListResponseDto>, "queryKey">;
};

export const useGetClaimHistoryListQuery = ({
  queryParams,
  options
}: UseGetClaimHistoryListQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimHistoryList({
      ...queryParams
    }).queryKey,
    queryFn: async () =>
      await OrderService.getClaimHistoryList({ payload: queryParams }),
    ...options
  });
};
